import type { Moment } from 'moment';

export const displayDateTimeString = (args: {
  startTime: Moment | null;
  endTime: Moment | null;
  format?: string;
}) => {
  const { startTime, endTime, format = 'YYYY/MM/DD' } = args;

  const startTimeString = startTime ? startTime.format(format) : '未定';
  const endTimeString = endTime ? endTime.format(format) : '未定';

  const text = `${startTimeString} 至 ${endTimeString}`;
  return text;
};
